import { Type } from 'typebox';
import { Attachment } from '../reference/attachment.js';
import { LibraryLanguage } from './library-language.js';
export const ReadyRosieVideoAge = Type.Object({
    name: Type.String()
});
export const ReadyRosieVideoClassType = Type.Object({
    id: Type.String(),
    name: Type.String()
});
export const ReadyRosieVideoObjective = Type.Object({
    id: Type.Optional(Type.String()),
    name: Type.Optional(Type.String()),
    dimension: Type.Optional(Type.String()),
    dimensionId: Type.Optional(Type.Number())
});
export const ReadyRosieVideo = Type.Object({
    id: Type.String({ minLength: 1 }),
    cmsId: Type.String({ minLength: 1 }),
    locale: LibraryLanguage,
    videoId: Type.Optional(Type.String()),
    attachments: Type.Array(Attachment),
    title: Type.Optional(Type.String()),
    summary: Type.Optional(Type.String()),
    ages: Type.Optional(Type.Array(ReadyRosieVideoAge)),
    classTypes: Type.Optional(Type.Array(ReadyRosieVideoClassType)),
    contentAreaIds: Type.Optional(Type.Array(Type.String())),
    curriculumCategoryIds: Type.Optional(Type.Array(Type.String())),
    locationIds: Type.Optional(Type.Array(Type.String())),
    productIds: Type.Optional(Type.Array(Type.String())),
    objectiveId: Type.Optional(Type.String()),
    objective: Type.Optional(ReadyRosieVideoObjective),
    tagList: Type.Optional(Type.String()),
    why: Type.Optional(Type.String()),
    challenge: Type.Optional(Type.String()),
    extend: Type.Optional(Type.String()),
    notReady: Type.Optional(Type.String()),
    journals: Type.Optional(Type.String()),
    books: Type.Optional(Type.String()),
    additionalResources: Type.Optional(Type.Unknown()),
    permalink: Type.Optional(Type.String()),
    thumbnail: Type.Optional(Type.String()),
    thumbnailPlay: Type.Optional(Type.String()),
    upOrDown: Type.Optional(Type.Unknown()),
    activityCompleted: Type.Optional(Type.Boolean()),
    favorited: Type.Optional(Type.Boolean()),
    vimeoId: Type.Optional(Type.String())
});
